import { defineMessages } from "react-intl";

export const Messages = defineMessages({
    Connecting: {
        id: "Connecting",
        defaultMessage: "Connecting..."
    },
    ConnectivityIssues: {
        id: "ConnectivityIssues",
        defaultMessage: "No connection with server, retrying..."
    },
    Settings: {
        id: "Settings",
        defaultMessage: "Settings"
    },
    AccessDenied: {
        id: "AccessDenied",
        defaultMessage: "It's not allowed to use Timeclock at this location {ip}. Please contact a Timeplan administrator if you should have access to this page."
    },
    NoSupport: {
        id: "NoSupport",
        defaultMessage: "Timeclock doesn't support Internet Explorer. Please use Chrome, Edge or Firefox instead."
    },
    EntryWaiting: {
        id: "EntryWaiting",
        defaultMessage: "Please identify yourself"
    },
    Welcome: {
        id: "Welcome",
        defaultMessage: "Welcome"
    },
    OfflineStamp: {
        id: "OfflineStamp",
        defaultMessage: "Choose one of the alternatives. (offline mode)"
    }
} as const);

export const Errors = defineMessages({
    Network: {
        id: "Errors.Network",
        defaultMessage: "Network error"
    }
} as const);

export const SelfRegistration = defineMessages({
    BadPersonNo: {
        id: "SelfRegistration.Errors.BadPersonNo",
        defaultMessage: "{personNo} is not a valid personal identification no"
    },
    Button: {
        id: "SelfRegistration.Button",
        defaultMessage: "Self register"
    },
    CompleteNoConfirm: {
        id: "SelfRegistration.CompleteNoConfirm",
        defaultMessage: "You are now registered in Timeplan and a temporary employment contract has been created. You will soon receive a text confirmation."
    },
    CompleteReactivated: {
        id: "SelfRegistration.CompleteReactivated",
        defaultMessage: "You are now re-activated in Timeplan and a new temporary employment contract has been created"
    },
    Step1EnterPersonNo: {
        id: "SelfRegistration.Step1EnterPersonNo",
        defaultMessage: "Step 1. Enter person no"
    },
    Step2EnterPhone: {
        id: "SelfRegistration.Step2EnterPhone",
        defaultMessage: "Step 2. Enter mobile"
    },
    Step3SelectCostDiv: {
        id: "SelfRegistration.Step3SelectCostDiv",
        defaultMessage: "Step 3. Select workplace"
    },
    Title: {
        id: "SelfRegistration.Title",
        defaultMessage: "Self register"
    },
    WelcomeText: {
        id: "SelfRegistration.WelcomeText",
        defaultMessage: "Welcome! Please complete this 3 step registration by entering your personal id number (YYYYMMDDXXXX), phone number, and your workplace. After these steps, you will receive a text message requesting more information, when you have completed the registration please log in using your employment number and select 'IN'. Note! Your employment number is in your text-message."
    }
} as const);
